import { Post } from '@wellesley/openapi'
import { isPublicChannel } from '@wellesley/group'

const getGroupChannelFromFeed = (feed?: Post) => {
  const author = feed?.author
  if (author?.channel && author?.groupName) return author

  const publisher = feed?.publisher
  if (publisher?.groupName) return publisher

  return undefined
}

const getFeedChannelInfo = (feed?: Post) => {
  const feedChannel = getGroupChannelFromFeed(feed)
  const isChannelPublic =
    !!feedChannel &&
    'groupPrivacy' in feedChannel &&
    isPublicChannel(feedChannel)

  return {
    feedChannel,
    isChannelPublic,
  }
}

export default getFeedChannelInfo
